import anny from "../../../../src/assets/aboutUs/anny.png";
import john from "../../../../src/assets/aboutUs/john.png";
import vic from "../../../../src/assets/aboutUs/vic.png";
import imo from '../../../../src/assets/aboutUs/imo.png';
import mfon from '../../../../src/assets/aboutUs/mfon.png';

const data = [
  {
    id: 1,
    imageSrc: anny,
    alt: "anny",
    name: "ANIEKAN UDO",
    designation: "CEO/MD",
    bio: "Engr. Aniekan Udo is the CEO of Hendrex Resources Limited, a leading Nigerian firm specializing in engineering, construction materials, logistics, and industrial waste management. A visionary leader, he drives innovation and excellence, ensuring quality in every project. Under his leadership, Hendrex Resources thrives as a trusted name in the industry.",
    facebooklink: "",
    twitterlink: "",
    linkedInlink: "",
  },
  {
    id: 2,
    imageSrc: john,
    alt: "john",
    name: "JOHN BASSEY",
    designation: "CEO",
    bio: "John Bassey is the CEO of Hendrex Resources Limited, a top Nigerian firm specializing in engineering, construction materials, logistics, and industrial waste management. Known for his strategic vision and dedication to quality, he has positioned the company as a trusted leader in delivering innovative solutions across diverse industries.",
    facebooklink: "https://www.facebook.com/iwere.o.eyitemi?mibextid=ZbWKwL",
    twitterlink: "https://x.com/IEyitemi?t=EaZKsoeubrkgV3k-gIYwGg&s=09",
    linkedInlink:
      "https://www.linkedin.com/in/eyitemi-onorume-849a50211?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  },
  {
    id: 3,
    imageSrc: vic,
    alt: "vic",
    name: "VICTOR FRANK",
    designation: "Architect",
    bio: "Victor Frank is the lead architect at Hendrex Resources Limited, a Nigerian firm specializing in engineering, construction materials, and industrial services. Known for his innovative designs and attention to detail, Victor plays a key role in shaping the company’s projects, delivering sustainable and functional architectural solutions that inspire excellence.",
    facebooklink: "https://web.facebook.com/brytebee",
    twitterlink: "https://x.com/brytebee",
    linkedInlink: "https://www.linkedin.com/in/brytebee",
  },
  {
    id: 4,
    imageSrc: imo,
    alt: "imo",
    name: "IMO DANIEL",
    designation: "Site Supervisor",
    bio: "Engr. Imo Daniel is a skilled civil engineer and site supervisor at Hendrex Resources Limited, a leading Nigerian firm in engineering and construction. With expertise in project management and on-site coordination, Imo ensures quality execution and timely delivery of projects. His dedication and leadership are vital to the company’s success.",
    facebooklink: "",
    twitterlink: "",
    linkedInlink: "",
  },
  {
    id: 5,
    imageSrc: mfon,
    alt: "mfon",
    name: "MFON AKPAN",
    designation: "Quantity Surveyor",
    bio: "Mfon Akpan is a proficient quantity surveyor at Hendrex Resources Limited, a top Nigerian firm specializing in engineering and construction. With expertise in cost estimation and project budgeting, Mfon ensures financial efficiency and resource optimization. His attention to detail and analytical skills are integral to the company’s project success.",
    // facebooklink: '',
    // twitterlink: '',
    // linkedInlink: '',
  },
];

export default data;
